import React, { useState, useEffect } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Modal,
  Select,
} from '@material-ui/core'
import NumberFormat from 'react-number-format'
import { useAuthentication } from '../../../../../context/authenticationContext'
import {
  getMIPYMESElegibleForCapacityBuilding,
  getMIPYMESElegibleForTechnicalAssistance,
  getProjectsElegibleForCapacityBuilding,
  getProjectsElegibleForTechnicalAssistance,
} from '../../../../../services/AsistenciaTecnica/get'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { getCurrencyByCountry } from '../../../../../services/Elegibilidad/get'
import {
  insertTechnicalAssistanceApplicant,
  ValidLimits,
} from '../../../../../services/AsistenciaTecnica/create'
import swal from 'sweetalert'
import { updateTechnicalAssistanceApplicant } from '../../../../../services/AsistenciaTecnica/put'
import { Autocomplete, TextField } from '@mui/material'

export const Modal13 = (props) => {
  const {
    open,
    setOpen,
    IdTechnicalAssistanceType,
    IdCurrency,
    getTechnicalAssistanceApplicantList,
    body,
    setBody,
    IdTechnicalAssistanceAnswer,
    RequestedAmount,
    NumberOfApplicants,
    CurrencyToDollarExchangeRate,
    data,
  } = props
  const { IdIFIToken, userCountry } = useAuthentication()

  const [mipymes, setMipymes] = useState([])
  const [projects, setProjects] = useState([])
  const [currencyType, setCurrencyType] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingData, setLoadingData] = useState(true)

  const GeneralDataSchema = Yup.object().shape({
    IdMipyme: Yup.number()
      .required('Esta campo es obligatorio')
      .typeError('Esta campo es obligatorio'),
    idProject: Yup.number()
      .required('Esta campo es obligatorio')
      .typeError('Esta campo es obligatorio'),
    RequestedAmount: Yup.number().required('Esta campo es obligatorio'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdTechnicalAssistanceApplicant: body.IdTechnicalAssistanceApplicant || 0,
      IdTechnicalAssistanceAnswer:
        body.IdTechnicalAssistanceAnswer || IdTechnicalAssistanceAnswer,
      IdMipyme: body.IdMipyme || null,
      idProject: body.idProject || '',
      RequestedAmount:
        body.RequestedAmount || RequestedAmount / NumberOfApplicants,
      RequestedAmountDollar: body.RequestedAmountDollar || null,
      MiPymeIdentifier: body.MiPymeIdentifier || '',
      ProjectPreElegibilityCode: body.ProjectCode || '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values)
    },
  })

  const saveForm = async (values) => {
    setLoading(true)
    try {
      const bodyLimit = {
        IdForm: formik.values.IdTechnicalAssistanceAnswer,
        IdProject: formik.values.idProject,
        Amount: RequestedAmount,
        PartialAmount: RequestedAmount / NumberOfApplicants,
        ExchangeRate: CurrencyToDollarExchangeRate,
        Action: 0,
        Validation: 1,
      }
      const responseLimit = await ValidLimits(bodyLimit)

      if (responseLimit.Success && responseLimit.Data.Message === false) {
        let response
        if (Object.keys(body).length === 0) {
          response = await insertTechnicalAssistanceApplicant(values)
        } else if (Object.keys(body).length > 0) {
          response = await updateTechnicalAssistanceApplicant(values)
        }
        if (response.Success) {
          swal({
            title: '¡Datos guardados exitosamente!',
            icon: 'success',
          })
          getTechnicalAssistanceApplicantList()
          handleClose()
          setLoading(false)
        }
      } else {
        if (responseLimit.Data.Message) setLoading(false)
        swal({
          title: `Ha ocurrido un problema`,
          // text: `${responseLimit.Data.MessageInfo[0].Message.split(':')}`,
          text: `${responseLimit.Data.MessageInfo[0].Message.split(
            ' : ',
          ).pop()}`,
          icon: `error`,
          closeOnClickOutside: false,
          closeOnEsc: false,
          buttons: {
            catch: {
              text: 'Continuar',
              value: 'catch',
            },
          },
        }).then((value) => {
          switch (value) {
            case 'catch':
              swal.close()
              break
            default:
              swal.close()
          }
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getMIPYMES = async () => {
    try {
      let response
      if (IdTechnicalAssistanceType === 4) {
        response = await getMIPYMESElegibleForTechnicalAssistance(IdIFIToken)
      }
      if (IdTechnicalAssistanceType === 5) {
        response = await getMIPYMESElegibleForCapacityBuilding(IdIFIToken)
      }
      if (response.Success) {
        setMipymes(response.Data)
        setLoadingData(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const result = mipymes.filter(
    (obj) => obj.IdMiPyme === formik.values.IdMipyme,
  )

  const resultProject = projects.filter(
    (obj) => obj.IdProject === formik.values.idProject,
  )

  // const validLimitMipyme = async () => {
  //   try {
  //     const bodyLimit = {
  //       IdForm: formik.values.IdTechnicalAssistanceAnswer,
  //       IdProject: formik.values.idProject,
  //       Amount: RequestedAmount,
  //       PartialAmount: RequestedAmount / NumberOfApplicants,
  //       ExchangeRate: CurrencyToDollarExchangeRate,
  //       Action: 0,
  //       Validation: 1,
  //     }
  //     const response = await ValidLimits(bodyLimit)
  //     console.log('el response', response)
  //     if (response.Success) {
  //       console.log('el response', response)
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const handleSelectMipyme = async (IdMipyme) => {
    try {
      let response
      if (IdTechnicalAssistanceType === 4) {
        response = await getProjectsElegibleForTechnicalAssistance(IdMipyme)
      }
      if (IdTechnicalAssistanceType === 5) {
        response = await getProjectsElegibleForCapacityBuilding(IdMipyme)
      }
      if (response.Success) {
        setProjects(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    if (formik.values.IdMipyme !== null)
      handleSelectMipyme(formik.values.IdMipyme)
  }, [formik.values.IdMipyme])

  // Función para obtener la moneda por pais
  const getListCurrencyByCountry = async () => {
    try {
      const response = await getCurrencyByCountry(userCountry)
      if (response.Success) {
        setCurrencyType(response.Data)
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    if (open) {
      getMIPYMES()
      getListCurrencyByCountry()
    }
  }, [IdTechnicalAssistanceType, open])

  useEffect(() => {
    getListCurrencyByCountry()
  }, [])

  const handleClose = () => {
    setOpen(false)
    formik.resetForm()
    setBody({})
    setProjects([])
    setMipymes([])
    setLoadingData(true)
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {!loadingData ? (
          <Box className="modalPYME">
            <div className="pymeDiv">
              <h1 className="pymeTitle">Datos de la MIPYME y el proyecto</h1>
            </div>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Nombre de la MIPYME <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  {(() => {
                    let uniqueMitigations = []
                    if (Object.keys(body).length > 0) {
                      uniqueMitigations = mipymes
                    } else {
                      const icludedIds = data.map((item) => item.IdMipyme)
                      if (data.length > 0 && mipymes.length > 0) {
                        uniqueMitigations = mipymes.filter((item, key) => {
                          return !icludedIds.includes(item.IdMiPyme)
                        })
                      } else {
                        uniqueMitigations = mipymes
                      }
                    }
                    return (
                      <Autocomplete
                        getOptionLabel={(option) =>
                          // `${option.TaxRegistration}` +
                          // ' / ' +
                          // option.BusinessName
                          `${option.TaxRegistration}` +
                          ' - ' +
                          option.BusinessName
                        }
                        disablePortal
                        id="combo-box-demo"
                        options={uniqueMitigations}
                        value={result[0]}
                        sx={{ width: '100%' }}
                        renderInput={(params) => <TextField {...params} />}
                        onChange={(e, value) => {
                          formik.setValues({
                            ...formik.values,
                            IdMipyme: value.IdMiPyme,
                            MiPymeIdentifier: value.TaxRegistration,
                          })
                        }}
                      />
                    )
                  })()}
                  {formik.errors.IdMipyme ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.IdMipyme}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Identificador de MIPYME
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="MiPymeCountry"
                    name="MiPymeCountry"
                    type="text"
                    variant="outlined"
                    sx={{ width: '100%' }}
                    disabled
                    value={formik.values.MiPymeIdentifier}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Nombre del proyecto <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  {/* <Select
                  id="IdProject"
                  name="IdProject"
                  variant="outlined"
                  value={formik.values.idProject}
                >
                  <MenuItem disabled value="">
                    Seleccione una opción
                  </MenuItem>
                  {projects &&
                    projects.map((item, key) => (
                      <MenuItem
                        value={item.IdProject}
                        key={key}
                        onClick={() =>
                          formik.setFieldValue('idProject', item.IdProject)
                        }
                      >
                        {item.SubprojectName}
                      </MenuItem>
                    ))}


                </Select> */}

                  {projects && (
                    <Autocomplete
                      getOptionLabel={(option) =>
                        option.ProjectPreElegibilityCode +
                        ' - ' +
                        option.SubprojectName
                      }
                      disablePortal
                      id="combo-box-demo"
                      options={projects}
                      value={resultProject[0]}
                      sx={{ width: '100%' }}
                      renderInput={(params) => <TextField {...params} />}
                      onChange={(e, value) => {
                        formik.setFieldValue('idProject', value.IdProject)
                        formik.setFieldValue(
                          'ProjectPreElegibilityCode',
                          value.ProjectPreElegibilityCode,
                        )
                      }}
                    />
                  )}
                  {formik.errors.idProject ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.idProject}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Código del proyecto</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="MiPymeCountry"
                    name="MiPymeCountry"
                    type="text"
                    variant="outlined"
                    sx={{ width: '100%' }}
                    disabled
                    value={formik.values.ProjectPreElegibilityCode}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">Moneda</label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <Select
                      id="IdProject"
                      name="IdProject"
                      variant="outlined"
                      value={IdCurrency}
                      disabled
                      style={{ height: '41px' }}
                    >
                      <MenuItem disabled value="">
                        Seleccione una opción
                      </MenuItem>
                      {currencyType &&
                        currencyType.map((item) => (
                          <MenuItem
                            key={item.IdCurrency}
                            value={item.IdCurrency}
                          >
                            {item.Description}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Monto Asistencia Técnica{' '}
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <NumberFormat
                      id="numberAss"
                      style={{ width: '100%' }}
                      customInput={TextField}
                      thousandSeparator={true}
                      variant="outlined"
                      allowNegative="false"
                      onChange={(e) => {
                        formik.setFieldValue(
                          'RequestedAmount',
                          Number(e.target.value.replaceAll(',', '')),
                        )
                      }}
                      value={formik.values.RequestedAmount}
                      error={formik.errors.RequestedAmount}
                      disabled
                      fixedDecimalScale
                      decimalScale={2}
                      allowLeadingZeros={false}
                    />
                    {formik.errors.RequestedAmount ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.RequestedAmount}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={handleClose}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  type="button"
                  onClick={validateFormStatus}
                  disabled={loading}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Box className="modalPYME">
            <Grid
              style={{
                alignItems: 'center',
                textAlign: 'center',
                alignContent: 'center',
                justifyContent: 'center',
                display: 'flex',
                paddingLeft: '50%',
              }}
            >
              <CircularProgress />
            </Grid>
          </Box>
        )}
      </Modal>
    </>
  )
}
